/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminInfoDTO } from '../models/AdminInfoDTO';
import type { AdminRequestListingFile } from '../models/AdminRequestListingFile';
import type { AdminRole } from '../models/AdminRole';
import type { AdminRoleInfo } from '../models/AdminRoleInfo';
import type { AssetFileInfo } from '../models/AssetFileInfo';
import type { AssetInfo } from '../models/AssetInfo';
import type { AssetType } from '../models/AssetType';
import type { BadgeInfoDTO } from '../models/BadgeInfoDTO';
import type { DynamicGameInfoDTO } from '../models/DynamicGameInfoDTO';
import type { EventInfoDTO } from '../models/EventInfoDTO';
import type { EventReward } from '../models/EventReward';
import type { GameCommentDTO } from '../models/GameCommentDTO';
import type { GameInfo } from '../models/GameInfo';
import type { GameInfoAndLikeStatus } from '../models/GameInfoAndLikeStatus';
import type { GamePresetDTO } from '../models/GamePresetDTO';
import type { GameVersionDTO } from '../models/GameVersionDTO';
import type { HiddenGameInfo } from '../models/HiddenGameInfo';
import type { LinearOrder } from '../models/LinearOrder';
import type { MonthlyAchievementRewardConfig } from '../models/MonthlyAchievementRewardConfig';
import type { NormalAchievementRewardConfig } from '../models/NormalAchievementRewardConfig';
import type { NotificationDTO } from '../models/NotificationDTO';
import type { PresetType } from '../models/PresetType';
import type { ProfileCommentDTO } from '../models/ProfileCommentDTO';
import type { RandomOrder } from '../models/RandomOrder';
import type { RecordUsageToken } from '../models/RecordUsageToken';
import type { ReqAddProfileComment } from '../models/ReqAddProfileComment';
import type { ReqConvertCoinToGold } from '../models/ReqConvertCoinToGold';
import type { ReqCreateBadge } from '../models/ReqCreateBadge';
import type { ReqGetZpsToken } from '../models/ReqGetZpsToken';
import type { ReqListingBadge } from '../models/ReqListingBadge';
import type { ReqListingUserBadge } from '../models/ReqListingUserBadge';
import type { ReqLoadProfileComment } from '../models/ReqLoadProfileComment';
import type { RequestBrowseOwnAsset } from '../models/RequestBrowseOwnAsset';
import type { RequestListingUserCharacter } from '../models/RequestListingUserCharacter';
import type { RequestMyRecentStory } from '../models/RequestMyRecentStory';
import type { RequestTopPlayedGame } from '../models/RequestTopPlayedGame';
import type { RequestTrendingStories } from '../models/RequestTrendingStories';
import type { RequestUserUseToken } from '../models/RequestUserUseToken';
import type { ReqUpdateBadge } from '../models/ReqUpdateBadge';
import type { ReqUpdateProfile } from '../models/ReqUpdateProfile';
import type { ResponseZpsTokenDTO } from '../models/ResponseZpsTokenDTO';
import type { ResultNewCommentAdded } from '../models/ResultNewCommentAdded';
import type { ReverseOrder } from '../models/ReverseOrder';
import type { StoryDataInEvent } from '../models/StoryDataInEvent';
import type { StoryJoinEventRequest } from '../models/StoryJoinEventRequest';
import type { StorySnapshotDTO } from '../models/StorySnapshotDTO';
import type { TotalTokenInOut } from '../models/TotalTokenInOut';
import type { UpdateEventRequest } from '../models/UpdateEventRequest';
import type { UserAchievementStatus } from '../models/UserAchievementStatus';
import type { UserBalanceDTO } from '../models/UserBalanceDTO';
import type { UserCharacterDTO } from '../models/UserCharacterDTO';
import type { UserInfoDTO } from '../models/UserInfoDTO';
import type { UserTrackingAction } from '../models/UserTrackingAction';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * @returns any ok
     * @throws ApiError
     */
    public static getApiGetGuestToken(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/get-guest-token',
        });
    }
    /**
     * exchange Google access token and device ID for a game token
     * @param requestBody
     * @returns ResponseZpsTokenDTO ok
     * @throws ApiError
     */
    public static postApiGetZpsToken(
        requestBody: ReqGetZpsToken,
    ): CancelablePromise<ResponseZpsTokenDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/get-zps-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * get server version info
     * @returns any ok
     * @throws ApiError
     */
    public static getApiVersionInfo(): CancelablePromise<{
        serverStaticVersion: string;
        assistantVersion: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/version-info',
        });
    }
    /**
     * get opening events
     * @returns EventInfoDTO ok
     * @throws ApiError
     */
    public static getApiOpeningEvents(): CancelablePromise<Array<EventInfoDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/opening-events',
        });
    }
    /**
     * @param requestBody
     * @returns StoryDataInEvent ok
     * @throws ApiError
     */
    public static postApiEventRank(
        requestBody: {
            eventId: number;
            offset: number;
            numTake: number;
        },
    ): CancelablePromise<Array<StoryDataInEvent>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/event-rank/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns StoryDataInEvent ok
     * @throws ApiError
     */
    public static postApiEventStoryVoteData(
        requestBody: {
            eventId: number;
            storyId: number;
        },
    ): CancelablePromise<StoryDataInEvent> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/event/story-vote-data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `story not join this event yet`,
            },
        });
    }
    /**
     * get all events that the authenticated user's stories have joined
     * @returns EventInfoDTO ok
     * @throws ApiError
     */
    public static getApiMyJoinedEvents(): CancelablePromise<Array<EventInfoDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/my-joined-events',
            errors: {
                401: `unauthorized`,
            },
        });
    }
    /**
     * get my info
     * @returns any ok
     * @throws ApiError
     */
    public static getApiUrlAssistant(): CancelablePromise<{
        url: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/url-assistant',
        });
    }
    /**
     * get my info and send device id
     * @param requestBody
     * @returns UserInfoDTO ok
     * @throws ApiError
     */
    public static postApiMe(
        requestBody: {
            deviceId: string;
        },
    ): CancelablePromise<UserInfoDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * get my info
     * @returns UserInfoDTO ok
     * @throws ApiError
     */
    public static getApiMe(): CancelablePromise<UserInfoDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/me',
        });
    }
    /**
     * get my coin and gold balance
     * @returns UserBalanceDTO ok
     * @throws ApiError
     */
    public static getApiBalance(): CancelablePromise<UserBalanceDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/balance',
        });
    }
    /**
     * convert coin to gold (coin is real-currency equivalent, goldEarned = coinAmount * rate)
     * @param requestBody
     * @returns UserBalanceDTO ok
     * @throws ApiError
     */
    public static postApiConvertCoinToGold(
        requestBody: ReqConvertCoinToGold,
    ): CancelablePromise<UserBalanceDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/convert-coin-to-gold',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * upload new asset
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUploadNewAsset(
        formData: {
            name: string;
            assetType: AssetType;
            fileExtension: string;
            file: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/upload-new-asset',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiDeleteAsset(
        requestBody: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/delete-asset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad id`,
            },
        });
    }
    /**
     * @param assetId
     * @returns AssetInfo ok
     * @throws ApiError
     */
    public static getApiAssetInfo(
        assetId: number,
    ): CancelablePromise<AssetInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/asset-info/{assetId}',
            path: {
                'assetId': assetId,
            },
            errors: {
                404: `not found id`,
            },
        });
    }
    /**
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUploadGame(
        formData: {
            file: Blob;
            changeLog: string;
            gameId: number;
            gameTitle: string;
            thumbFile: Blob;
            description: string;
            tag: string;
            localize?: Blob;
            originLanguage: string;
            isPremium: boolean;
            /**
             * json string event id request to join
             */
            joinEvent: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/upload-game',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Upload a new snapshot for a story. If overwrite is false (default), currentSnapshotId must match the latest snapshot id for the story.
     * @param formData
     * @returns any Snapshot uploaded successfully
     * @throws ApiError
     */
    public static postApiUploadStorySnapshot(
        formData: {
            /**
             * ID of the story/game
             */
            gameId: number;
            /**
             * ID of the snapshot client currently has. Must be the latest snapshot id unless overwrite is true. Pass 0 if no snapshots exist yet.
             */
            currentSnapshotId: number;
            /**
             * The snapshot content file
             */
            file: Blob;
            /**
             * If true, skip snapshot id validation and save directly. Default: false
             */
            overwrite?: boolean;
        },
    ): CancelablePromise<{
        /**
         * ID of the newly created snapshot
         */
        snapshotId: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/upload-story-snapshot',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Missing required fields`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Download a story snapshot file. Only the owner of the story can download.
     * @param gameId
     * @param snapshotId
     * @returns binary Snapshot file downloaded successfully
     * @throws ApiError
     */
    public static getApiDownloadStorySnapshot(
        gameId: number,
        snapshotId: number,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/download-story-snapshot/{gameId}/{snapshotId}',
            path: {
                'gameId': gameId,
                'snapshotId': snapshotId,
            },
            errors: {
                400: `Invalid snapshot ID`,
                401: `Unauthorized`,
                404: `Snapshot not found`,
            },
        });
    }
    /**
     * @returns any ok
     * @throws ApiError
     */
    public static postApiCreateNewGame(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/create-new-game',
        });
    }
    /**
     * @param requestBody
     * @returns AssetInfo ok
     * @throws ApiError
     */
    public static postApiBrowseMyAsset(
        requestBody: RequestBrowseOwnAsset,
    ): CancelablePromise<Array<AssetInfo>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/browse-my-asset',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GameInfo ok
     * @throws ApiError
     */
    public static postApiMyGames(
        requestBody: {
            /**
             * 0 = start (no cap). Otherwise return games with id < capMaxId.
             */
            capMaxId: number;
            numTake: number;
        },
    ): CancelablePromise<Array<GameInfo>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/my-games',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GameVersionDTO ok
     * @throws ApiError
     */
    public static postApiMyGameVersions(
        requestBody: {
            gameId: number;
            maxVersionId?: number;
            numTake: number;
        },
    ): CancelablePromise<Array<GameVersionDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/my-game-versions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns NotificationDTO ok
     * @throws ApiError
     */
    public static postApiGetNotifications(
        requestBody: {
            maxId?: number;
            numTake: number;
        },
    ): CancelablePromise<NotificationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/get-notifications',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GameInfoAndLikeStatus ok
     * @throws ApiError
     */
    public static postApiMyRecentStory(
        requestBody: RequestMyRecentStory,
    ): CancelablePromise<Array<GameInfoAndLikeStatus>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/my-recent-story',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiReadNotification(
        requestBody: {
            notificationId?: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/read-notification',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiVoteGame(
        requestBody: {
            gameId: number;
            numStars: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/vote-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiCommentGame(
        requestBody: {
            gameId: number;
            comment: string;
            repToId?: number;
        },
    ): CancelablePromise<{
        newId?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/comment-game',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `bad request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns GameCommentDTO ok
     * @throws ApiError
     */
    public static postApiLoadComment(
        requestBody: {
            gameId: number;
            parentId?: number;
            minId: number;
            numTake: number;
        },
    ): CancelablePromise<Array<GameCommentDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/load-comment',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiGetSystemConfig(
        requestBody: {
            key: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/get-system-config',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUpdateLocalize(
        requestBody: {
            gameId: number;
            languageId: string;
            content: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/update-localize',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiTrackingViewGame(
        requestBody: {
            gameId: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tracking/view-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiTrackingPlayedSession(
        requestBody: {
            /**
             * time count in second
             */
            playTime: number;
            gameId: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tracking/played-session',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiTrackingEndGame(
        requestBody: {
            gameId: number;
            endId: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tracking/end-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiTrackingUseToken(
        requestBody: RequestUserUseToken,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tracking/use-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiTrackingDoAction(
        requestBody: {
            action: UserTrackingAction;
            gameId?: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tracking/do-action',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiTrackingDynamicGamePlaySession(
        requestBody: {
            gameId: number;
            deviceId: string;
            /**
             * Session này có phải là session chơi lại hay không
             */
            sessionReplay: boolean;
            durationInSeconds: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tracking/dynamic-game/play-session',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `dynamic game not found`,
            },
        });
    }
    /**
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUserCharacterNew(
        formData: {
            name: string;
            description: string;
            thumb: Blob;
            content: string;
        },
    ): CancelablePromise<{
        id: number;
        savePath: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user-character/new',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUserCharacterUpdate(
        formData: {
            id: number;
            name: string;
            description: string;
            content: string;
            thumb: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user-character/update',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                404: `user character not found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns UserCharacterDTO ok
     * @throws ApiError
     */
    public static postApiUserCharacterListing(
        requestBody: RequestListingUserCharacter,
    ): CancelablePromise<Array<UserCharacterDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user-character/listing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the latest snapshot for each novel owned by the authenticated user. Paginated by novelId.
     * @param requestBody
     * @returns StorySnapshotDTO ok
     * @throws ApiError
     */
    public static postApiStorySnapshots(
        requestBody: {
            /**
             * Cursor: pass the last novelId from the previous page
             */
            minNovelId?: number;
            numTake?: number;
        },
    ): CancelablePromise<Array<StorySnapshotDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/story-snapshots',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * delete all snapshots for a story owned by the authenticated user
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiClearAllSnapshots(
        requestBody: {
            gameId: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/clear-all-snapshots',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * List snapshots for a specific game owned by the authenticated user, paginated by snapshot id.
     * @param requestBody
     * @returns StorySnapshotDTO ok
     * @throws ApiError
     */
    public static postApiSnapshotHistory(
        requestBody: {
            gameId: number;
            /**
             * Cursor: pass the last snapshot id from the previous page. 0 = start.
             */
            maxId?: number;
            numTake?: number;
        },
    ): CancelablePromise<Array<StorySnapshotDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/snapshot-history',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * List dynamic games in reverse order (newest first), cursor-based pagination by id
     * @param requestBody
     * @returns DynamicGameInfoDTO ok
     * @throws ApiError
     */
    public static postApiDynamicGamesListing(
        requestBody: {
            /**
             * Cursor: pass the last id from the previous page. 0 = start from newest.
             */
            maxId?: number;
            numTake: number;
        },
    ): CancelablePromise<Array<DynamicGameInfoDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/dynamic-games-listing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get dynamic game info by id
     * @param id
     * @returns DynamicGameInfoDTO ok
     * @throws ApiError
     */
    public static getApiDynamicGame(
        id: number,
    ): CancelablePromise<DynamicGameInfoDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/dynamic-game/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `invalid id`,
                404: `not found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns GameVersionDTO ok
     * @throws ApiError
     */
    public static postAdminApiBrowseReview(
        requestBody: {
            minGameId: number;
            numTake: number;
        },
    ): CancelablePromise<Array<GameVersionDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/browse-review',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GameVersionDTO ok
     * @throws ApiError
     */
    public static postAdminApiGameVersions(
        requestBody: {
            gameId: number;
            maxVersionId?: number;
            numTake: number;
        },
    ): CancelablePromise<Array<GameVersionDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/game-versions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiApproveGameVersion(
        requestBody: {
            gameId: number;
            versionId: number;
            rating: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/approve-game-version',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiRejectGameVersion(
        requestBody: {
            gameId: number;
            versionId: number;
            rejectedReason: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/reject-game-version',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns AdminInfoDTO ok
     * @throws ApiError
     */
    public static getAdminApiInfo(): CancelablePromise<AdminInfoDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin-api/info',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiForceHideGame(
        requestBody: {
            gameId: number;
            reasonHide: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/force-hide-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiReEnableGame(
        requestBody: {
            gameId: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/re-enable-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiAddDomain(
        requestBody: {
            domain: string;
            roles: Array<AdminRole>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/add-domain',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiSetRole(
        requestBody: {
            domainToSet: string;
            roles: Array<AdminRole>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/set-role',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns HiddenGameInfo ok
     * @throws ApiError
     */
    public static postAdminApiBrowseHiddenGames(
        requestBody: {
            maxId: number;
            numTake: number;
        },
    ): CancelablePromise<Array<HiddenGameInfo>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/browse-hidden-games',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns AdminRoleInfo ok
     * @throws ApiError
     */
    public static postAdminApiListingAdmin(
        requestBody: {
            minDomain: string;
            numTake: number;
        },
    ): CancelablePromise<Array<AdminRoleInfo>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/listing-admin',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GamePresetDTO ok
     * @throws ApiError
     */
    public static postAdminApiListingPreset(
        requestBody: {
            minId?: number;
            numTake: number;
            nameQuery?: string;
            type?: PresetType;
            adminRecommend?: boolean;
            ownerId?: number;
        },
    ): CancelablePromise<Array<GamePresetDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/listing-preset',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiChangePresetRecommended(
        requestBody: any,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/change-preset-recommended',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiQueryNumStoryCreate(
        requestBody: {
            /**
             * timestamp second
             */
            startTime: number;
            /**
             * timestamp second
             */
            endTime: number;
        },
    ): CancelablePromise<{
        numStoryCreated: number;
        allAuthorIds: Array<number>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/query-num-story-create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiTopViewedStory(
        requestBody: {
            numTop: number;
            startTime: number;
            endTime: number;
        },
    ): CancelablePromise<Array<{
        gameInfo: GameInfo;
        uniqueView: number;
        avgPlayingTime: number;
        medianTimePlay: number;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/top-viewed-story',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns RecordUsageToken ok
     * @throws ApiError
     */
    public static postAdminApiQueryUsageToken(
        requestBody: {
            minId: number;
            from: number;
            to: number;
            numTake: number;
        },
    ): CancelablePromise<Array<RecordUsageToken>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/query-usage-token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns UserCharacterDTO ok
     * @throws ApiError
     */
    public static postAdminApiListingUserCharacter(
        requestBody: RequestListingUserCharacter,
    ): CancelablePromise<Array<UserCharacterDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/listing-user-character',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiUpdateUserCharacter(
        requestBody: {
            id: number;
            adminDescription: string;
            /**
             * not send if not change current value
             */
            recommendThisCharacter?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/update-user-character',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiModifyGame(
        requestBody: {
            gameId: number;
            /**
             * not send if not change
             */
            recommend?: boolean;
            /**
             * not send if not change
             */
            adminDescription?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/modify-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiSetConfig(
        requestBody: {
            key: string;
            value: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/set-config',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiGetConfig(
        requestBody: {
            key: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/get-config',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns AssetFileInfo ok
     * @throws ApiError
     */
    public static postAdminApiListingAssetFolder(
        requestBody: AdminRequestListingFile,
    ): CancelablePromise<Array<AssetFileInfo>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/listing-asset-folder',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string ok
     * @throws ApiError
     */
    public static postAdminApiExeRawSqlQuery(
        requestBody: {
            query: string;
        },
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/exe-raw-sql-query',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GameInfoAndLikeStatus ok
     * @throws ApiError
     */
    public static postApiListingGame(
        requestBody: {
            numTake: number;
            nameQuery?: string;
            genre?: Array<number>;
            order: (LinearOrder | RandomOrder | ReverseOrder);
            /**
             * not send if not care about admin
             */
            adminSelected?: boolean;
            authorId?: number;
        },
    ): CancelablePromise<Array<GameInfoAndLikeStatus>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/listing-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * get top played games
     * @param requestBody
     * @returns GameInfoAndLikeStatus ok
     * @throws ApiError
     */
    public static postApiTopPlayedGame(
        requestBody: RequestTopPlayedGame,
    ): CancelablePromise<Array<GameInfoAndLikeStatus>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/top-played-game',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * get trending stories (top viewed) in a period of time
     * @param requestBody
     * @returns GameInfoAndLikeStatus ok
     * @throws ApiError
     */
    public static postApiTrendingStories(
        requestBody: RequestTrendingStories,
    ): CancelablePromise<Array<GameInfoAndLikeStatus>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/trending-stories',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param gameId
     * @returns GameInfoAndLikeStatus ok
     * @throws ApiError
     */
    public static getApiGameInfo(
        gameId: any,
    ): CancelablePromise<GameInfoAndLikeStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/game-info/{gameId}',
            path: {
                'gameId': gameId,
            },
            errors: {
                400: `bad game id`,
                404: `not found game`,
            },
        });
    }
    /**
     * @param userId
     * @returns UserInfoDTO ok
     * @throws ApiError
     */
    public static getApiProfile(
        userId: any,
    ): CancelablePromise<UserInfoDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/profile/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                400: `bad user id`,
                404: `user not found`,
            },
        });
    }
    /**
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postApiPresetNew(
        formData: {
            content: string;
            name: string;
            thumb: Blob;
        },
    ): CancelablePromise<{
        presetId: number;
        path: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/preset/new',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestBody
     * @returns GamePresetDTO ok
     * @throws ApiError
     */
    public static postApiPresetListing(
        requestBody: {
            minId?: number;
            numTake: number;
            nameQuery?: string;
        },
    ): CancelablePromise<Array<GamePresetDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/preset/listing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns GamePresetDTO ok
     * @throws ApiError
     */
    public static postApiPresetRecommended(
        requestBody: {
            nameQuery?: string;
            minId?: number;
            numTake?: number;
        },
    ): CancelablePromise<Array<GamePresetDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/preset/recommended',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postApiPresetUpdate(
        formData: {
            id: number;
            name?: string;
            thumb?: Blob;
            content?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/preset/update',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param requestBody
     * @returns any Premium route purchased successfully
     * @throws ApiError
     */
    public static postApiBuyPremiumRoute(
        requestBody: {
            /**
             * The story/game ID
             */
            storyId: number;
            /**
             * The premium route ID to purchase (price: 100 coins)
             */
            routeId: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/buy-premium-route',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Insufficient coins, or already owned`,
            },
        });
    }
    /**
     * @param storyId
     * @returns any List of owned premium route IDs for the story
     * @throws ApiError
     */
    public static getApiOwnedPremiumRoute(
        storyId: number,
    ): CancelablePromise<{
        owned?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/owned-premium-route',
            query: {
                'storyId': storyId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiStoryJoinEvent(
        requestBody: StoryJoinEventRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/story-join-event',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Not the story owner`,
                404: `Story not found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUserVoteStoryEvent(
        requestBody: {
            eventId: number;
            storyId: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user-vote-story-event',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiUpdateProfile(
        requestBody: ReqUpdateProfile,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/update-profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ResultNewCommentAdded ok
     * @throws ApiError
     */
    public static postApiProfileComment(
        requestBody: ReqAddProfileComment,
    ): CancelablePromise<ResultNewCommentAdded> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/comment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns ProfileCommentDTO ok
     * @throws ApiError
     */
    public static postApiProfileLoadProfileComment(
        requestBody: ReqLoadProfileComment,
    ): CancelablePromise<Array<ProfileCommentDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/load-profile-comment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * show or hide a profile comment
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiProfileInactiveComment(
        requestBody: {
            commentId: number;
            isShow: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/inactive-comment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns BadgeInfoDTO ok
     * @throws ApiError
     */
    public static postApiProfileBadgeListing(
        requestBody: ReqListingUserBadge,
    ): CancelablePromise<Array<BadgeInfoDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/profile/badge/listing',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Coins awarded successfully
     * @throws ApiError
     */
    public static postAdminApiAwardCoin(
        requestBody: {
            /**
             * Target user ID
             */
            userId: number;
            /**
             * Number of coins to add (must be > 0)
             */
            amount: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/award-coin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid amount (must be > 0)`,
                403: `Permission denied (requires award_coin action)`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns TotalTokenInOut ok
     * @throws ApiError
     */
    public static postAdminApiQueryTotalTokenInOut(
        requestBody: {
            startTime: number;
            endTime: number;
            requestTypes: Array<string>;
        },
    ): CancelablePromise<TotalTokenInOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/query-total-token-in-out',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiTopUserUseImageGen(
        requestBody: {
            startTime: number;
            endTime: number;
        },
    ): CancelablePromise<{
        data: Record<string, number>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/top-user-use-image-gen',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiTopUserUseImageGenCost(
        requestBody: {
            startTime: number;
            endTime: number;
            numTake: number;
        },
    ): CancelablePromise<{
        data: Record<string, number>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/top-user-use-image-gen-cost',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiTopUserUseAgentCost(
        requestBody: {
            startTime: number;
            endTime: number;
            numTake: number;
        },
    ): CancelablePromise<{
        data: Record<string, number>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/top-user-use-agent-cost',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiCountImageGenerated(
        requestBody: {
            startTime: number;
            endTime: number;
            requestGenImage: Array<string>;
        },
    ): CancelablePromise<{
        numImageGenerated: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/count-image-generated',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns TotalTokenInOut ok
     * @throws ApiError
     */
    public static postAdminApiQueryTotalTokenInOutByReqType(
        requestBody: {
            startTime: number;
            endTime: number;
            requestType: string;
        },
    ): CancelablePromise<TotalTokenInOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/query-total-token-in-out-by-req-type',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiCreateNewEvent(
        requestBody: {
            name: string;
            description: string;
            bannerUrl: string;
            startTime: number;
            endTime: number;
            reward: EventReward;
        },
    ): CancelablePromise<{
        newEventId: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/create-new-event',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiUpdateEvent(
        requestBody: UpdateEventRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/update-event',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EventInfoDTO ok
     * @throws ApiError
     */
    public static postAdminApiListEvents(): CancelablePromise<Array<EventInfoDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/list-events',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns BadgeInfoDTO ok
     * @throws ApiError
     */
    public static postApiBadgeListing(
        requestBody: ReqListingBadge,
    ): CancelablePromise<Array<BadgeInfoDTO>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/badge/listing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiBadgeCreate(
        requestBody: ReqCreateBadge,
    ): CancelablePromise<{
        newId: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/badge/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postApiBadgeUpdate(
        requestBody: ReqUpdateBadge,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/badge/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request or badge not found`,
            },
        });
    }
    /**
     * @param badgeId
     * @returns BadgeInfoDTO ok
     * @throws ApiError
     */
    public static getApiBadgeDetail(
        badgeId: number,
    ): CancelablePromise<BadgeInfoDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/badge/detail/{badgeId}',
            path: {
                'badgeId': badgeId,
            },
            errors: {
                400: `Invalid badge ID or badge not found`,
            },
        });
    }
    /**
     * get the current user's progress toward all normal achievements
     * @returns UserAchievementStatus ok
     * @throws ApiError
     */
    public static getAchievementNormalAchievementProgress(): CancelablePromise<UserAchievementStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/achievement/normal-achievement-progress',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns NormalAchievementRewardConfig ok
     * @throws ApiError
     */
    public static getAchievementNormalConfig(): CancelablePromise<NormalAchievementRewardConfig> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/achievement/normal-config',
        });
    }
    /**
     * @returns MonthlyAchievementRewardConfig ok
     * @throws ApiError
     */
    public static getAchievementMonthlyConfig(): CancelablePromise<MonthlyAchievementRewardConfig> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/achievement/monthly-config',
        });
    }
    /**
     * update normal achievement reward config
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAchievementUpdateNormalAchievementConfig(
        requestBody: NormalAchievementRewardConfig,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/achievement/update-normal-achievement-config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * update monthly achievement reward config
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAchievementUpdateMonthlyAchievementConfig(
        requestBody: MonthlyAchievementRewardConfig,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/achievement/update-monthly-achievement-config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiCreateDynamicGame(
        requestBody: {
            gameTitle: string;
            gameDescription: string;
        },
    ): CancelablePromise<{
        gameId: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/create-dynamic-game',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param formData
     * @returns any ok
     * @throws ApiError
     */
    public static postAdminApiUploadDynamicGame(
        formData: {
            gameId: number;
            newTitle: string;
            newDescription: string;
            file: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin-api/upload-dynamic-game',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `missing required fields`,
                401: `Unauthorized`,
            },
        });
    }
}
